<template>
  <el-dialog
    title="企业评价得分自评记录"
    :visible.sync="visible"
    top="25vh"
    width="600px"
    :lock-scroll="false"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <div v-loading="isLoading" element-loading-text="拼命加载中">
      <el-table
        :data="queryList"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column
          prop="createTime"
          label="评价得分自评时间"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="score"
          label="企业评价得分自评分数"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="操作" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <a
              href="javascript:;"
              class="clickable-link"
              @click="
                redirectByPathBlank(
                  `/admin/serviceManage/qualificationEvaluateScore`,
                  {
                    id: scope.row.id
                  }
                )
              "
              >查看详细</a
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fn-text-center mt-20">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="true"
          :total="total"
          :page-size="queryCondition.pageSize"
          :current-page.sync="queryCondition.pageIndex"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    userId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      visible: true,
      //查询条件
      queryCondition: {
        pageIndex: 1,
        pageSize: 5
      },
      total: 0,
      //是否处于loading状态
      isLoading: true,
      //查询结果
      queryList: []
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    // 关闭弹框后回调
    closeDialog() {
      // 传递关闭上一级
      this.$emit("close", true);
    },
    //获取列表
    loadList() {
      //初始化
      // this.queryList = [];
      this.isLoading = true;
      this.$api("service", "getQualificationScoreCount", {
        ...this.queryCondition,
        userId: this.userId
      }).then((res) => {
        this.isLoading = false;
        this.total = res.count;
        this.queryList = res.dataList;
      });
    },
    //点击切换分页触发
    handleCurrentChange() {
      this.loadList();
    }
  }
};
</script>

<style lang="less" scoped></style>
